import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxUnchecked = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Icons_UI_Checkbox_Check-Box_OFF",
	"data-name": "Icons & UI/Checkbox/Check-Box_OFF",
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Radio-Box_OFF",
		transform: "translate(4.5 4.5)",
		fill: "#fff",
		stroke: "#cbcfd8",
		strokeWidth: 1,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 27,
			rx: 2,
			stroke: "none"
		}), /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 26,
			height: 26,
			rx: 1.5,
			fill: "none"
		})]
	})
});
export { SvgCheckboxUnchecked as ReactComponent };
